import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';

import { AppinfoService } from 'app/services/appinfo.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { GfoService, ColumnFilter, Gfo, FilterOperatorName, ColumnOperator } from './../../services/gfo.service';
import { RequestTableService } from 'app/services/request-table.service';

@Component({
	selector: 'app-common-column-filter',
	templateUrl: './common-column-filter.component.html',
	styleUrls: ['./common-column-filter.component.css']
})
export class CommonColumnFilterComponent implements OnInit, OnChanges {

	@Input() filter: ColumnFilter;

	@Input() columns = [];
	// Field used to display
	@Input() displayField = 'name';
	// Field used to store column name
	@Input() colNameField = 'prop';
	//
	@Input() filterInfo: any = {};
	//
	@Input() isAutoCheckDomain: boolean; // If true, the domain of the selected column will be checked on select
	@Input() domainFilter: ColumnFilter[] = [];
	//
	@Output() onChange: EventEmitter<ColumnFilter> = new EventEmitter();
	@Output() onPressEnter: EventEmitter<any> = new EventEmitter();
	// Selected column
	public selectedColumn = null;
	public selectedOperator;
	public filterValue: any;
	public valueList: any[];

	public domainList: any[] = [];
	public domainDisplayCol: string;
	public exceedMaxSelectedDom: boolean; // Selected domains exceed the max number of allowed selection
	// public selectedInDomain: any[] = []; // Selected values in the domain list
	public showDomain = false;
	// Columns' available operators
	// public operators: ColumnOperator[];
	public availableOperators: ColumnOperator[] = [];

	// Operators that doesn't need to pass filterValue
	public noFilterValueOperatorNames: FilterOperatorName[] = ['is empty', 'is null', 'not empty', 'not null'];

	constructor(
		private appinfoService: AppinfoService,
		private commonService: CommonFunctionService,
		private gfoService: GfoService,
		private requestTableService: RequestTableService
	) { }

	transformFilterInfo() {

	}


	async onSelectColumn(skipTriggerChange?: boolean) {
		if (this.selectedColumn) {
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				//
				const info = this.appinfoService.columnMap[this.selectedColumn[this.colNameField]];
				if (info) {
					let colType = info.type;
					let standardColType = this.appinfoService.findGeneralCol(colType);
					this.availableOperators = Object.keys(this.appinfoService.filterOperators).filter((i: FilterOperatorName) => {
						return this.appinfoService.filterOperators[i].compatibleColTypes.indexOf(standardColType) > -1;
					})
					.map((i: FilterOperatorName) => {
						return {
							name: this.appinfoService.filterOperators[i].name,
							symbol: this.appinfoService.filterOperators[i].label,
							sq: this.appinfoService.filterOperators[i].sq
						}
					}).sort((a, b) => {
						if (a.sq > b.sq) {
							return 1;
						} else if (a.sq < b.sq) {
							return -1;
						} else {
							return 0;
						}
					});
					// this.gfoService.columnOperators.filter((o) => {
					// 	return this.appinfoService.filterOperators[o.name] && this.appinfoService.filterOperators[o.name].compatibleColTypes.indexOf(standardColType) > -1
					// });
				} else {
					this.availableOperators = [];
				}
				// Get domain
				if (this.isAutoCheckDomain) {
					await this.populateColumnDomain();
				}
			} catch (err) {
				console.log(err);
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		} else {
			this.availableOperators = [];
		}
		// Update selectedOperator
		if (this.selectedOperator) {
			this.selectedOperator = this.availableOperators.find(o => o.name === this.selectedOperator.name);
		}
		// this.selectedInDomain = []; // Clear selected domains
		this.updateFilter(skipTriggerChange);
	}
	onSelectOperator(skipTriggerChange?: boolean) {
		this.updateFilter(skipTriggerChange);
	}
	updateFilter(skipTriggerChange?: boolean) {
		//
		if (this.selectedOperator) {
			if (this.selectedOperator.name === 'is null') {
				this.filterValue = 'null';
			} else if (this.noFilterValueOperatorNames.indexOf(this.selectedOperator.name) > -1) {
				this.filterValue = '';
			}
		}
		if (!skipTriggerChange) {
			this.onChange.emit(this.getCurrentFilter());
		}
	}
	setDefaultOperator() {
		this.selectedOperator = this.availableOperators[0]; // this.operators[0]; // Hard Code.
	}
	clearFilterValue() {
		this.valueList = null;
		this.filterValue = null;
	}
	clearAll(skipTriggerChange?: boolean) {
		this.selectedColumn = null;
		this.selectedOperator = null;
		this.clearFilterValue();
		this.updateFilter(skipTriggerChange);
	}
	getCurrentFilter(): ColumnFilter {
		// If the filter is not completely defined, return null
		if (!this.selectedColumn || !this.selectedOperator) {
			return null;
		}
		if (!this.filterValue && this.filterValue !== 0 && this.noFilterValueOperatorNames.indexOf(this.selectedOperator.name) === -1) {
			return null;
		}
		if (this.selectedOperator.name === 'not empty') {
			return this.gfoService.getFilter(
				this.selectedColumn[this.colNameField],
				'ne',
				''
			);
		} else if (this.selectedOperator.name === 'is empty') {
			return this.gfoService.getFilter(
				this.selectedColumn[this.colNameField],
				'eq',
				''
			);
		} else {
			return this.gfoService.getFilter(
				this.selectedColumn[this.colNameField],
				this.selectedOperator.name,
				this.filterValue
			);
		}
	}
	onEnter() {
		this.onPressEnter.emit();
	}

	public toggleDomain() {
		this.showDomain = !this.showDomain;
	}
	public onSelectDomain() {
		const selected = this.domainList.filter((d) => d.selected);
		if (selected.length >= 5) {
			this.exceedMaxSelectedDom = true;
		} else {
			this.exceedMaxSelectedDom = false;
		}
		if (selected.length) { // If there're selected values, use IN as operator
			this.selectedOperator = this.availableOperators.find((o) => o.name === 'in');
			this.filterValue.value = selected.map((d) => d[this.domainDisplayCol]); // stringify is for display use
			// Update filterValue.displayed based on filterValue.value
			let displayed = this.filterValue.value[0];
			for (let i = 1; i < this.filterValue.value.length; i++) {
				displayed += ',' + this.filterValue.value[i];
			}
			this.filterValue.displayed = displayed;
		} else {
			this.filterValue = this.getEmptyFilterValue();
		}
		this.updateFilter();
	}
	private async populateColumnDomain() {
		const columnMap = this.appinfoService.columnMap;
		const info = columnMap[this.selectedColumn[this.colNameField]];
		if (info && info.fkTab && info.name) {
			try {
				let gfo;
				if (this.domainFilter && this.domainFilter.length) {
					gfo = this.gfoService.getGfo(
						this.gfoService.filterLogics.and,
						this.domainFilter
					);
				}
				const rsp: any = await this.requestTableService.tableGet(info.fkTab, info.fkCol, gfo, {
					pageNumber: 0
				}, true);
				this.domainList = rsp.data;
				this.domainDisplayCol = info.name;
			} catch (err) {
				console.log(err);
				this.domainList = [];
			}
		} else {
			this.domainList = [];
		}
	}
	private getEmptyFilterValue() {
		return {
			displayed: null,
			value: null
		};
	}
	ngOnInit() {
		// // Default selectedOperator
		// this.selectedOperator = this.operators[0];
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.filter && changes.filter.currentValue) {
			const filter: ColumnFilter = changes.filter.currentValue;
			const selectedCol = this.columns.find(c => c[this.colNameField] === filter.col);
			if (selectedCol !== this.selectedColumn) {
				this.selectedColumn = selectedCol;
				this.onSelectColumn(true);
			}
			const selectedOp = this.availableOperators.find(o => o.name === filter.op);
			if (selectedOp !== this.selectedOperator) {
				this.selectedOperator = selectedOp;
				this.onSelectOperator(true);
			}
			this.filterValue = filter.val;
		}
		// Clear filters outside the component
			// if (changes.columns && !changes.columns.firstChange) {
			// 	this.selectedColumn = null;
			// 	this.onChange.emit(null);
			// 	this.selectedOperator = null; // this.operators[0];
			// 	this.filterValue = null;
			// }
	}
}
